import { motion } from "framer-motion";
import { STATS } from "@/lib/content";

const ABOUT_IMG =
    "https://images.pexels.com/photos/1529034/pexels-photo-1529034.jpeg";

export default function AboutSection() {
    return (
        <section
            data-testid="about-section"
            className="relative py-24 bg-[#0A0A0B] overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9 }}
                        className="lg:col-span-5 relative"
                    >
                        <div className="aspect-[4/5] relative overflow-hidden border border-white/10">
                            <img
                                src={ABOUT_IMG}
                                alt="Stockholm skyline — BM Juridik"
                                className="w-full h-full object-cover object-center"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent" />
                        </div>
                        <div className="hidden lg:block absolute -bottom-8 -right-8 bg-[#C4A977] text-black p-8 max-w-[240px]">
                            <p className="font-serif text-5xl leading-none">
                                6
                            </p>
                            <p className="mt-2 text-xs tracking-[0.2em] uppercase">
                                Kontor i Sverige
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, delay: 0.1 }}
                        className="lg:col-span-7"
                    >
                        <p className="overline">Om BM Juridik</p>
                        <h2 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.1]">
                            En byrå där{" "}
                            <span className="italic text-[#C4A977]">
                                varje ord
                            </span>{" "}
                            väger tungt.
                        </h2>
                        <div className="hairline my-8 max-w-xs" />
                        <p className="text-[#A1A1AA] text-base lg:text-lg leading-relaxed">
                            BM Juridik är en personlig juristbyrå som
                            kombinerar storbyråns skärpa med det nära
                            engagemanget. Vi är en familjeledd verksamhet som
                            dagligen företräder svenska och internationella
                            klienter i komplexa ärenden — med personligt
                            ansvar i varje uppdrag.
                        </p>
                        <p className="mt-5 text-[#A1A1AA] text-base leading-relaxed">
                            Vi tror på lyhördhet, integritet och ett långsiktigt
                            partnerskap. Vår ambition är alltid densamma — att
                            vara den juridiska rådgivare våra klienter ringer
                            först.
                        </p>

                        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
                            {STATS.map((s) => (
                                <div
                                    key={s.label}
                                    data-testid={`stat-${s.label.slice(0, 10)}`}
                                    className="border-l border-[#C4A977]/40 pl-4"
                                >
                                    <p className="font-serif text-3xl lg:text-4xl text-[#F4F4F5]">
                                        {s.number}
                                    </p>
                                    <p className="mt-1 text-xs text-[#A1A1AA] uppercase tracking-wider">
                                        {s.label}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
